import styled from "styled-components";

export const MenuItemLabel = styled.div`
    width: 100%;
`;

export const Wrapper = styled.div`
    background-color: ${(props) =>
        props.active ? globalThis.config.colors.gray8 : "initial"};
`;
